import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { XpoSelectModule } from '@xpo-ltl/ngx-ltl-core/select';
import { EnvironmentCd } from '@xpo-ltl/sdk-common';

@Component({
  selector: 'environment-selector',
  templateUrl: './environment-selector.component.html',
  styleUrls: ['./environment-selector.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, XpoSelectModule],
})
export class EnvironmentSelectorComponent {
  @Input()
  control: FormControl;

  @Input()
  labelInside = false;

  environments = EnvironmentCd;

  constructor() {}
}
